import { faFacebook, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import IconButton from '../button/icon'
import NavLink from './link'
import { Link, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopyright, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { useState, useEffect, useContext } from 'react'
import { createClient } from '@sanity/client'
import { fetchSiteConfigData } from '../../api'
import { toast } from 'react-toastify'
import COPY from '../../utils/copy'
import WindowWidthContext from '../../context/window'

export default function Footer() {
  const windowWidth = useContext(WindowWidthContext)
  const [isLoading, setIsLoading] = useState(true)
  const [siteConfigData, setSiteConfigData] = useState<{
    facebook: string
    instagram: string
    whatsapp: string
    email: string
    businessName: string
    logoUrl: string
  } | null>(null)

  useEffect(() => {
    const client = createClient({
      projectId: COPY.SANITY_PROJECT_ID,
      dataset: COPY.SANITY_DATASET,
      apiVersion: COPY.SANITY_API_VERSION,
      useCdn: true,
    })

    client
      .fetch(fetchSiteConfigData)
      .then((data) => {
        setSiteConfigData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        }),
      )
    setIsLoading(false)
  }, [])

  const location = useLocation()
  const isTermsPage = location.pathname === COPY.TERMS_URL
  const isPrivacyPage = location.pathname === COPY.PRIVACY_URL
  const isCookiesPage = location.pathname === COPY.COOKIES_URL

  const currentYear = () => new Date().getFullYear()

  return (
    <div className='w-full h-12 sm:h-16 bg-white shadow-inner flex flex-row justify-evenly items-center'>
      <div
        className={
          windowWidth && windowWidth >= 680 && windowWidth <= 950
            ? 'hidden'
            : 'flex flex-row items-center h-12 sm:h-16'
        }
      >
        <Link to={COPY.HOME_URL}>
          <img
            src={isLoading ? '' : siteConfigData?.logoUrl}
            alt={COPY.LOGO_ALT}
            height={32}
            width={173}
          />
        </Link>
      </div>
      <div className='flex flex-row items-center h-12 sm:h-16'>
        <IconButton
          icon={faWhatsapp}
          className='text-white max-sm:hidden'
          link={isLoading ? '#' : siteConfigData?.whatsapp}
        />
        <IconButton
          icon={faInstagram}
          className='text-white max-sm:hidden'
          link={isLoading ? '#' : siteConfigData?.instagram}
        />
        <IconButton
          icon={faFacebook}
          className='text-white max-sm:hidden'
          link={isLoading ? '#' : siteConfigData?.facebook}
        />
        <IconButton
          icon={faEnvelope}
          className='text-white max-sm:hidden'
          link={isLoading ? '#' : 'mailto:' + siteConfigData?.email}
        />
      </div>
      <div
        className={
          windowWidth && windowWidth <= 680 ? 'hidden' : 'flex flex-row items-center h-12 sm:h-16'
        }
      >
        {!isTermsPage && <NavLink link={COPY.TERMS_URL} content={COPY.TERMS} />}
        {!isPrivacyPage && <NavLink link={COPY.PRIVACY_URL} content={COPY.PRIVACY} />}
        {!isCookiesPage && <NavLink link={COPY.COOKIES_URL} content={COPY.COOKIES} />}
      </div>
      <div className='flex flex-row items-center h-12 sm:h-16'>
        <p className='flex flex-row justify-start items-center h-12 sm:h-16 pt-1 font-medium tracking-wide'>
          {currentYear()}
          <FontAwesomeIcon icon={faCopyright} size={'lg'} className='mx-2 sm:mx-3' />
          {isLoading ? '' : siteConfigData?.businessName}
        </p>
      </div>
    </div>
  )
}
